import clsx from 'clsx';
import { ButtonHTMLAttributes, forwardRef, PropsWithChildren } from 'react';
import { ReactComponent as ButtonLoader } from 'src/shared/components/icons/button-loader.svg';

import { twMerge } from 'tailwind-merge';

export interface BaseButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'filled' | 'outlined';
  className?: string;
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}

export const BaseButton = forwardRef<HTMLButtonElement, PropsWithChildren<BaseButtonProps>>(
  ({ children, className, isLoading, size = 'md', ...rest }, ref) => {
    return (
      <button
        ref={ref}
        className={twMerge(
          clsx(
            'flex items-center justify-center font-aeonik font-medium rounded-2 px-4 cursor-pointer',
            {
              'h-10.5 text-[1.25rem]/[1.25rem]': size === 'sm',
              'h-16 text-[1.5rem]/[1.6rem]': size === 'md',
              'h-20 text-[2.5rem]/[2.85rem]': size === 'lg',
            },
            isLoading && 'pointer-events-none',
            className
          )
        )}
        {...rest}
      >
        {isLoading ? <ButtonLoader className="w-6 h-6 animate-infinitely-spinning" /> : children}
      </button>
    );
  }
);
